// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React,{useState}  from "react";
import {Modal} from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";

// Validation schema
const CustomerEditSchema = Yup.object().shape({
  sufix: Yup.string()
  .min(1, "Minimum 1 symbols")
  .max(50, "Maximum 50 symbols")
  .required('Field is necesssary'),
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required('Field is necesssary'),
    description: Yup.string().optional()

});
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({ ...client, ...values })
          .then(() => setSubmitting(false))
          .end((err) => {
            setSubmitting(false)
          })
        }}
      >
        {({ handleSubmit, handleChange, errors }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  {/* Last Name */}
                  <div className="col-lg-6">
                    <Field
                      name="sufix"
                      component={Input}
                      placeholder="sufix"
                      label="sufix"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Metric Name"
                      label="Metric Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <Field
                      name="description"
                      component={Input}
                      placeholder="Description"
                      label="Description"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">{/* Gender */}</div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                  onClick={() => {
                    setSubmitting(true)
                    handleSubmit()
                    setTimeout(() => {
                      setSubmitting(true)

                    }, 2000)
                  }}
                  disabled={isSubmitting}
                  className="btn btn-primary btn-elevate"
                >
                  {isSubmitting ?
                    <div className="d-flex align-items-center">
                      <div className="mr-2">Loading...</div>
                      <div className="spinner spinner-white mr-10"></div>
                    </div> : "Save"}
                </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Metric" : "New Metric"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Metric</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Metric</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
